/**
 * /signed-out route. Public, sits OUTSIDE the Layout so it isn't gated by
 * AuthGate (which would silent-SSO the user right back in and make sign-out
 * feel broken). Detects `?everywhere=1` (set after a full Microsoft sign-out)
 * and renders broader-scope copy in that case.
 */

import { useSearchParams } from 'react-router-dom';
import { getLoginUrl } from '@/lib/useSession';
import { useDocumentTitle } from '@/lib/useDocumentTitle';

export function SignedOut() {
  useDocumentTitle();
  const [params] = useSearchParams();
  const everywhere = params.get('everywhere') === '1';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-candy-cream px-4 dark:bg-candy-dark-bg">
      <div className="w-full max-w-md rounded-lg border border-candy-line bg-candy-white p-8 text-center shadow-1 dark:border-candy-dark-line dark:bg-candy-dark-surface">
        <p className="mb-2 text-xs uppercase tracking-wide text-candy-pink dark:text-candy-pink-dark">
          The Sweet Spot
        </p>
        <h1 className="mb-3 text-2xl font-semibold text-candy-ink dark:text-candy-dark-ink">
          {everywhere
            ? "You've been signed out of Microsoft 365"
            : "You've been signed out of The Sweet Spot"}
        </h1>
        <p className="mb-6 text-sm text-candy-ink-muted dark:text-candy-dark-ink-muted">
          {everywhere
            ? 'Your Sweet Spot, Outlook, Teams, and other Microsoft 365 apps are all signed out. Signing back in will require your password and MFA.'
            : 'Your session is closed. Your Microsoft 365 or Google sign-in stays active, so signing back in will be one click.'}
        </p>
        <a
          href={getLoginUrl('/')}
          className="inline-flex items-center justify-center rounded-md bg-candy-pink px-4 py-2 text-sm font-medium text-white hover:opacity-90 dark:bg-candy-pink-dark dark:text-candy-dark-bg"
        >
          Sign in to The Sweet Spot
        </a>
      </div>
    </div>
  );
}
